import axios from "../../../utils/axios";
import { handleError } from "../../../utils/common-utils";

export const fetchSavedCards = async () => {
  return await axios.get("/payments/paystack/saved-authorizations/");
};

export const performSavedCardTransaction = ({
  requestDetails,
  onSuccess,
  onFailure,
}) => {
  axios
    .post("/payments/paystack/charge", { ...requestDetails })
    .then(({ data }) => {
      const { paused, reference } = data.data;

      if (!paused) {
        fetchTransactionId(reference, onSuccess, onFailure);
      } else {
        // TODO: Handle OTP Flow
      }
    })
    .catch((error) => {
      const message = handleError(error);
      onFailure(message);
    });
};

const fetchTransactionId = (reference, onSuccess, onFailure) => {
  axios
    .get(`/payments/paystack/${reference}`)
    .then(({ data }) => {
      onSuccess(data.id);
    })
    .catch((error) => {
      const message = handleError(error);
      onFailure(message);
    });
};
